import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { formatEUR } from "../lib/api";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const cfg = { withCredentials: true };

export default function AccountPage() {
  const { user, loading, logout } = useAuth();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    if (user && user.role === "customer") {
      document.title = "Mi cuenta · Mimes Gourmet";
      axios.get(`${API}/customer/orders`, cfg).then((r) => setOrders(r.data)).catch(() => {});
    }
  }, [user]);

  if (loading) return <div className="p-16 text-center">Cargando…</div>;
  if (!user || user.role !== "customer") return <Navigate to="/cuenta/entrar" replace />;

  return (
    <div className="max-w-4xl mx-auto px-5 sm:px-8 py-16">
      <div className="flex items-center justify-between flex-wrap gap-4">
        <div>
          <p className="eyebrow mb-2">Tu cuenta</p>
          <h1 className="font-serif text-4xl text-[color:var(--brand-primary)] font-light">Hola, <span className="italic text-[color:var(--brand-terracotta)]">{user.name}</span></h1>
          <p className="text-sm text-[color:var(--brand-neutral)] mt-2">{user.email}</p>
        </div>
        <Button data-testid="account-logout" variant="outline" onClick={logout}>Cerrar sesión</Button>
      </div>

      <div className="mt-12">
        <h2 className="font-serif text-2xl text-[color:var(--brand-primary)]">Tus pedidos</h2>
        {orders.length === 0 ? (
          <p data-testid="orders-empty" className="mt-6 text-sm text-[color:var(--brand-neutral)]">Aún no has realizado ningún pedido.</p>
        ) : (
          <div data-testid="orders-list" className="mt-6 space-y-3">
            {orders.map((o) => (
              <div key={o.session_id} className="bg-white border border-[color:var(--brand-border)] rounded-md p-4 flex flex-wrap items-center gap-4">
                <div className="flex-1 min-w-0">
                  <p className="font-mono text-xs text-[color:var(--brand-neutral)]/70">Ref: {o.session_id?.slice(-14)}</p>
                  <p className="text-sm mt-1">{o.items?.length || 0} productos · {new Date(o.created_at).toLocaleDateString("es-ES")}</p>
                </div>
                <span className="font-serif text-lg text-[color:var(--brand-primary)]">{formatEUR(o.amount || 0)}</span>
                <span className={`text-xs px-2 py-1 rounded-full ${o.payment_status === "paid" ? "bg-[color:var(--brand-sage)]/20 text-[color:var(--brand-sage)]" : "bg-[color:var(--brand-bg-alt)]"}`}>
                  {o.payment_status === "paid" ? "Pagado" : o.payment_status}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
